<template>
  <div class="main">
    <!-- 导航栏部分 -->
    <div class="nav">
      <van-nav-bar
        title="电子健康卡信息"
        left-arrow
        @click-left="onClickLeft"
      />
    </div>
    <div>
      <div class="qr_box">
        <!-- 二维码弹出层 -->
        <img
          src="../ElectronicHealthCard/PictureHealthCardImg/logo_.png"
          alt=""
          srcset=""
          class="icon"
        />
        <!-- <ProductQrcode :qrcode="qrcodestr" :width="width" :height="height" /> -->
        <div id="qrcode1" ref="qrcode1"></div>
        <div class="flush" @click="flushHealthCardByQRCode">
          点击
          <p>刷新</p>
        </div>
        <div class="hint">就诊时出示此二维码</div>
      </div>
      <div class="IDinformation">
        <van-cell-group>
          <van-cell title="姓名" :value="carlist.name" />
          <van-cell title="身份证" :value="carlist.id_number |hideMiddle" />
        </van-cell-group>
      </div>
    </div>
 <van-popup v-model="showcode" round :style="{ height: '50%' , width:'70%'}" closeable>
     <div class="popqrcode_box">
       <div class="popqrcode_text">就诊卡号</div>
     <ProductQrcode :qrcode="pid" :width="width" :height="height" class="popqrcode" />
       <div class="popqrcode_text">{{pid}}</div>
     </div>
      </van-popup>
    <div class="entranceBtn" @click="entranceBtn">进 入 卡 包</div>
    <div class="entranceBtn" @click="showProductQrcode">患者二维码</div>
    <div class="unbundle" @click="removehealthcard">解 绑 电 子 健 康 卡</div>
  </div>
</template>

<script>
import Nav from "../ElectronicHealthCard/components/nav.vue";
import ProductQrcode from "../ElectronicHealthCard/components/ProductQrcode";
import QRCode from "qrcodejs2";
export default {
  components: {
    Nav,
    ProductQrcode,
  },
  created() {
    this.carlist = this.$route.query.carlist;
    this.name = this.$route.query.name;
    this.id_number = this.$route.query.id_number;
    this.id_type = this.$route.query.id_type;
    this.healthcardid = this.$route.query.healthcardid;
    this.pid = this.$route.query.pid;
    this.getHealthCardByQRCode();
  },
  mounted(index) {
    // 获取上个页面传递过来的参数
  },
  data() {
    return {
      carlist: [],
      show: true,
      qrcodestr: "",
      width: 165,
      height: 165,
      carlist: [],
      imgsrc: "",
      name: "",
      id_number: "",
      id_type: "",
      healthcardid: "",
      pid:"",
      showcode:false,
      showcedestr:"",
      qr1:""
    };
  },
    filters: {
    hideMiddle(val) {
      return `${val.substring(0, 4)}**********${val.substring(val.length - 4)}`;
    },
  },
  methods: {

  async  removehealthcard(){
        try {
        this.$showLoad();
        let data = {
          pid: this.pid,
        };
        let url = "/healthcardcontroller/removehealthcard";
        await this.$axios_request.axios_request_body(
          "nodeserver",
          url,
          "POST",
          data,
          (data) => {
          
            if (data.status == 200) {
               this.$toast.success('解绑成功')
                setTimeout(() => {
                   this.$router.push({
                    path: "/HealthcardList",
                  });
                }, 1000);
                return
            } else {
              this.$toast.fail('网络连接失败，请稍后解绑')
            }
          }
        );
      } catch (error) {}
    },
    showProductQrcode(){

      // this.qrcodestr =cardno
      this.showcode=true
    },
    crateQrcode() {
      this.qr = new QRCode("qrcode1", {
        width: this.width,
        height: this.height, // 高度
        text: this.qrcodestr, // 二维码内容
      });
    },
    // 返回首页
    onClickLeft() {
      this.$router.go(-1);
    },
    // 返回健康卡管理列表
    async entranceBtn() {
      try {
        this.$showLoad();
        let data = {
          qrCodeText: this.qrcodestr,
        };
        let url = "/healthcardcontroller/getOrderByOutAppId";
        await this.$axios_request.axios_request_body(
          "nodeserver",
          url,
          "POST",
          data,
          (data) => {
            let redirect_uri = "http://account.kmmds.top/HealthcardList";
            this.$hideLoad();
            if (data.status == 200) {
           
              window.location.href = `https://health.tengmed.com/open/takeMsCard?order_id=${data.data.data.rsp.orderId}&redirect_uri=${redirect_uri}`;
            } else {
              this.$toast.fail('网络连接失败，请稍后重试')
            }
          }
        );
      } catch (error) {}
    },
    flushHealthCardByQRCode() {
      this.$refs.qrcode1.innerHTML = "";
      this.getHealthCardByQRCode();
    },
    async getHealthCardByQRCode() {
      try {
        this.$showLoad();
        let data = {
          // qrCodeText:this.carlist.qrCodeText
          healthCardId: this.healthcardid,
          idType: this.id_type,
          idNumber: this.id_number,
          codeType: "0",
        };
        let url = "/healthcardcontroller/getDynamicQRCode";
        await this.$axios_request.axios_request_body(
          "nodeserver",
          url,
          "POST",
          data,
          (data) => {
            console.log(data);
            this.$hideLoad();
            if (data.status != 200) {
              this.$toast.fail("请求失败请稍后重试");
            } else {
              this.qrcodestr = data.data.data.rsp.qrCodeText;
              this.crateQrcode();
              // console.log( this.qrcodestr)
              // this.imgsrc=data.data.data.rsp.qrCodeImg
            }
          }
        );
      } catch (error) {}
    },
  },
};
</script>

<style lang="scss" scoped>
.main {
  width: 100%;
  height: 100%;
  background-color: rgb(245, 245, 245);
  .popqrcode_box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  width: 100%;
  height: 100%;
  .popqrcode {
    margin-top:2vh;
    margin-bottom: 3vh;
  }
  .popqrcode_text {
    text-align: center;
    font-size: 16px;
  }
}
}

.qrcodeimg {
  width: 40vw;
  height: 23vh;
}

.qr_box {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-around;
  flex-direction: column;
  width: 90%;
  height: 250px;
  background-color: #fff;
  margin: 15px auto;
  font-size: 12px;

  .flush p {
    display: inline;
    color: green;
  }
  .hint {
    font-size: 15px;
  }
}
.qr_box .icon {
  position: absolute;
  top: 36%;
  left: 44%;
  transform: translateX(-50%);
  transform: translateY(-50%);
  width: 44px;
  height: 44px;
}

.IDinformation {
  width: 90%;
  background-color: #fff;
  margin: 0 auto;
}
.entranceBtn,
.unbundle {
  border: 1px solid #5b8df6;
  display: flex;
  align-items: center;
  height: 5vh;
  justify-content: center;
  font-size: 12px;
  color: #ffffff;
  width: 90%;
  line-height: 5vh;
  border-radius: 5px;
  margin: 15px auto;
}
.entranceBtn {
  background-color: #5b8df6;
}
.unbundle {
  color: #5b8df6;
  line-height: 5vh;
  font-size: 16px;
}
</style>
